<template>
  <li class="section-sub-menu" @click.stop="toggle">
    <a class="level-name">
      {{ level.name }}
      <i :class="['fa', 'fa-fw', 'float-end', open ? 'fa-angle-up' : 'fa-angle-down']"></i>
    </a>
    <ul :class="['sub-menu-list', { 'sub-menu-list--open': open }]">
      <li
        v-for="section in level.sections"
        :key="section.key"
        :class="{active: currentSection.key === section.key}"
      >
        <a @click.stop="setSection(section)">{{ section.displayName }}</a>
      </li>
      <SectionSubMenu
        v-for="subSectionLevel in level.subSections"
        :key="subSectionLevel.name"
        :level="subSectionLevel"
      />
    </ul>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    level: { type: Object }
  },
  components: {
    SectionSubMenu: () => import('./SectionSubMenu.vue')
  },
  data() {
    return {
      open: this.level.key === 'Settings'
    }
  },
  computed: {
    ...mapGetters(['currentSection'])
  },
  methods: {
    toggle() {
      this.open = !this.open
    },
    setSection(section) {
      this.$store.commit('setSectionSelected')
      this.$store.commit('setCurrentSection', section)
    }
  }
}
</script>

<style scoped>
.section-sub-menu {
  cursor: pointer;
  color: #fff;
  a {
    text-decoration: none;
  }
}

.level-name {
  padding: 15px 15px;
  display: block;
  color: #9d9d9d;
}

.sub-menu-list {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, opacity 0.3s ease;
  opacity: 0;
  padding: 0;
  list-style: none;
}

.sub-menu-list--open {
  max-height: 1500px;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/SectionSubMenu.vue